module.exports = __webpack_public_path__ + "img/login-default-bg.45ea7221.png";